import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function StatusCard({ color, icon, title, amount, wide = false }) {
    return (
        <article className={`ae-account-stat ae-account-stat--${color}${wide ? ' ae-account-stat--wide' : ''}`}>
            <div className="ae-account-stat-icon">
                <FontAwesomeIcon icon={icon} />
            </div>
            <div className="ae-account-stat-content">
                <p>{title}</p>
                <strong>{amount || '—'}</strong>
            </div>
        </article>
    );
}
